<template lang="pug" src="./menu.pug"></template>

<script>
import Loader from 'components/loader/loader'
import HeroPagesImage from 'components/hero/hero-pages-image/hero-pages-image'
import CustomMenuSection from 'components/custom/custom-menu-section/custom-menu-section'
import CustomMenuRamen from 'components/custom/custom-menu-ramen/custom-menu-ramen'
import CustomMenuRamenLayout from 'components/custom/custom-menu-ramen-layout/custom-menu-ramen-layout'
import CustomMenuLimited from 'components/custom/custom-menu-limited/custom-menu-limited'
import CustomMenuCustomization from 'components/custom/custom-menu-customization/custom-menu-customization'
import CustomMenuBeyond from 'components/custom/custom-menu-beyond/custom-menu-beyond'

export default {
  computed: {
    props () {
      return this.$store.state.pages['menu']
    }
  },
  components: {
    Loader,
    HeroPagesImage,
    CustomMenuSection,
    CustomMenuRamen,
    CustomMenuRamenLayout,
    CustomMenuLimited,
    CustomMenuCustomization,
    CustomMenuBeyond
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/menu/menu.vue